import { useState , useEffect } from "react";
import { useQuery } from "@apollo/client";
import {
    Autocomplete,
    TextField,
    Stack,
    Typography,
    Box,
    IconButton,
  } from "@mui/material";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EmptyImge from "../../Assets/empty-image.png"; 
import { SELECT_UNIT_BYID_MATERIAL } from "../../Schema/Reqpurchase";

export default function ItemMaterialUnit({
    e, 
    materialId,
    setCheckUnit,
    handleUpdateList,  
    requiredField,  
    checkUnit,
}) { 

    const [unitOptions, setUnitOptions] = useState([]);
    const { refetch: refetchUnit } = useQuery(SELECT_UNIT_BYID_MATERIAL, {
      variables: {
        materialId: materialId,
      },
      onCompleted: ({ selectUnitByMaterialId }) => {
        // console.log("selectUnitByMaterialId:::", selectUnitByMaterialId);
        if (selectUnitByMaterialId?.length > 0) {
          const unitData = selectUnitByMaterialId?.map((e) => {
            return {
              id: e?._id,
              title: e?.unitId?.unitKhName, 
            };
          });
          setUnitOptions(unitData);
        } else {
          setUnitOptions([]);
        }
      },
      onError: (error) => {
        console.log(error?.message);
      },
    }); 
     
    useEffect(() => {
      refetchUnit();
    }, [checkUnit, materialId]);

    return( 
      <Stack width="15%" direction="column" justifyContent="center">
        <Autocomplete
          value={e.listMaterialUnitId}
          options={unitOptions}
          onChange={(event, val) => {
            setCheckUnit(true);
            handleUpdateList(e.key, val, "listMaterialUnitId");
          }}
          getOptionLabel={(option) =>
            option?.title === undefined ? "ជ្រើសរើស" : option?.title
          }
          isOptionEqualToValue={(option, value) =>
            option?.value === value?.value
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              placeholder={"ជ្រើសរើស"}
              error={
                (requiredField &&
                  e?.listMaterialUnitId?.id === undefined) ||
                (requiredField && e?.listMaterialUnitId?.id === "")
                  ? true
                  : false
              }
            />
          )}
        />
      </Stack>  
    )
}